import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
import { classNames } from "../../../utils";
export const EtherscanLogo = t0 => {
  const $ = _c(17);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== className || $[7] !== fill) {
    t4 = classNames(fillVariants({
      fill
    }), className);
    $[6] = className;
    $[7] = fill;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== size) {
    t5 = {
      width: size,
      height: size
    };
    $[9] = size;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <g transform="translate(-219.378 -213.33)"><path d="M280.433,353.152A12.45,12.45,0,0,1,292.941,340.7l20.737.068a12.467,12.467,0,0,1,12.467,12.467v78.414c2.336-.692,5.332-1.43,8.614-2.2a10.389,10.389,0,0,0,8.009-10.11V322.073a12.469,12.469,0,0,1,12.468-12.47h20.778a12.469,12.469,0,0,1,12.467,12.467v90.279s5.2-2.106,10.269-4.245a10.408,10.408,0,0,0,6.353-9.577V290.9a12.466,12.466,0,0,1,12.466-12.467h20.778A12.468,12.468,0,0,1,450.815,290.9v88.625c18.014-13.055,36.271-28.758,50.759-47.639a20.926,20.926,0,0,0,3.185-19.537,146.6,146.6,0,0,0-136.644-99.006c-81.439-1.094-148.744,65.385-148.736,146.834a146.371,146.371,0,0,0,19.5,73.45,18.56,18.56,0,0,0,17.707,9.173c3.931-.346,8.825-.835,14.643-1.518a10.383,10.383,0,0,0,9.209-10.306V353.152" data-name="Path 1" id="Path_1" /><path d="M244.417,398.641A146.808,146.808,0,0,0,477.589,279.9c0-3.381-.157-6.724-.383-10.049-53.642,80-152.686,117.4-232.79,128.793" data-name="Path 2" id="Path_2" transform="translate(35.564 80.269)" /></g>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== fillAttribute || $[13] !== rest || $[14] !== t4 || $[15] !== t5) {
    t7 = <svg className={t4} fill={fillAttribute} style={t5} viewBox="0 0 293.775 293.671" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[12] = fillAttribute;
    $[13] = rest;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};